/**
 * Save blocker categories that are re-derived from hierarchy replacement state.
 */
export type DerivedSaveBlockerType = "singles" | "domainReplacements";

/**
 * Save blocker categories produced by field-level hierarchy validation.
 */
export type ValidationSaveBlockerType = "hierarchyName" | "phase" | "reportType";

/**
 * Save blocker categories used across hierarchy validation and replacement validation.
 */
export type SaveBlockerType = DerivedSaveBlockerType | ValidationSaveBlockerType;

/**
 * A single validation warning that blocks saving.
 * The `type` field indicates which category this blocker belongs to
 * (e.g., "singles", "domainReplacements", "phase", "reportType").
 */
export interface ISaveBlocker {
  /** Unique identifier for the save blocker */
  id: string;
  /** Category type for the blocker */
  type: SaveBlockerType;
  /** Optional warning message to display to the user */
  warningText?: string;
}

/**
 * Unified set of save blockers held at app level.
 * Contains all validation warnings that block saving, organized as a flat set
 * with type discrimination via the `type` field on each blocker.
 */
export type ISaveBlockers = Set<ISaveBlocker>;
